module.exports = __webpack_public_path__ + "static/img/5.7f09a483.jpg";